module.exports = __webpack_public_path__ + "static/img/Nino Utopie Preguntando.ba9627d5.svg";